export type TrackingStatus = "test" | "live";

export function isRunningUnderTest(): boolean {
  // Karma/Jasmine inject these onto the global scope during a test run.
  const scope = window as unknown as Record<string, unknown>;
  return scope["__karma__"] !== undefined || scope["jasmine"] !== undefined;
}

export function resolveTrackingStatus(): TrackingStatus {
  return isRunningUnderTest() ? "test" : "live";
}
